import { useContext } from 'react';

import { ToastContext, ToastContextValue } from '../contexts';

export const useToast = (): ToastContextValue => {
  return useContext(ToastContext)!;
};
